module.exports = __webpack_public_path__ + "static/11-insights-2-76d4a895552463bee111eb2151af222e.jpg";